"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCheckoutConfig = exports.getCheckoutConfig = exports.getIsIframe = exports.getInterlocutor = exports.getAppHost = exports.MissingConfigurationField = void 0;
let checkoutConfig = {};
class MissingConfigurationField extends Error {
    constructor(fieldName) {
        super(`Missing field in the configuration: ${fieldName}`);
        Object.setPrototypeOf(this, MissingConfigurationField.prototype);
    }
}
exports.MissingConfigurationField = MissingConfigurationField;
const getAppHost = () => {
    if (!checkoutConfig.host) {
        throw new MissingConfigurationField('host');
    }
    return checkoutConfig.host;
};
exports.getAppHost = getAppHost;
const getInterlocutor = () => ((0, exports.getIsIframe)() ? (0, exports.getAppHost)() : window.location.origin);
exports.getInterlocutor = getInterlocutor;
const getIsIframe = () => !!checkoutConfig.iframe;
exports.getIsIframe = getIsIframe;
const getCheckoutConfig = () => checkoutConfig;
exports.getCheckoutConfig = getCheckoutConfig;
// const announceDeprecatedField = (oldField: string, newField: string) => {
//    console.warn('[ctc] DEPRECATED: ' + oldField + ' is deprecated, please use ' + newField + ' instead');
// }
const updateCheckoutConfig = (newConfig, reset = false) => {
    if (reset)
        checkoutConfig = {};
    // if ('callbackUrl' in newConfig) announceDeprecatedField('callbackUrl', 'returnUrl')
    checkoutConfig = {
        //not documented
        iframe: 'iframe' in newConfig ? !!newConfig.iframe : checkoutConfig.iframe,
        // deprecated
        applicationId: 'applicationId' in newConfig ? newConfig.applicationId : checkoutConfig.applicationId,
        callbackUrl: 'callbackUrl' in newConfig ? newConfig.callbackUrl : checkoutConfig.callbackUrl,
        sellerId: 'sellerId' in newConfig ? newConfig.sellerId : checkoutConfig.sellerId,
        // documented
        accessToken: 'accessToken' in newConfig ? newConfig.accessToken : checkoutConfig.accessToken,
        applicationKey: 'applicationKey' in newConfig ? newConfig.applicationKey : checkoutConfig.applicationKey,
        returnUrl: 'callbackUrl' in newConfig ? newConfig.returnUrl : checkoutConfig.returnUrl,
        cartId: 'cartId' in newConfig ? newConfig.cartId : checkoutConfig.cartId,
        locale: 'locale' in newConfig ? newConfig.locale : checkoutConfig.locale,
        projectKey: 'sellerId' in newConfig ? newConfig.projectKey : checkoutConfig.projectKey,
        storeKey: 'storeKey' in newConfig ? newConfig.storeKey : checkoutConfig.storeKey,
        host: 'host' in newConfig ? newConfig.host : checkoutConfig.host,
        skipShipping: 'skipShipping' in newConfig ? newConfig.skipShipping : checkoutConfig.skipShipping,
        styles: 'styles' in newConfig ? newConfig.styles : checkoutConfig.styles,
        languageOverrides: 'languageOverrides' in newConfig
            ? newConfig.languageOverrides
            : checkoutConfig.languageOverrides,
        forms: 'forms' in newConfig ? newConfig.forms : checkoutConfig.forms,
        currencyLocale: 'currencyLocale' in newConfig ? newConfig.currencyLocale : checkoutConfig.currencyLocale,
        showTaxes: 'showTaxes' in newConfig ? newConfig.showTaxes : checkoutConfig.showTaxes,
    };
    return checkoutConfig;
};
exports.updateCheckoutConfig = updateCheckoutConfig;
//# sourceMappingURL=config.js.map